export default __webpack_public_path__ + "static/media/sustainability.26404c84.svg";